export default {
  labels: {
    today: 'Dziś',
    pickup_time: 'Czas odbioru',
    on_site_time: 'Czas podania',
    delivery_time: 'Czas dostawy',
  },
};
